
import moment from "moment";

import { ActionContext } from "vuex";
import { CustomerStateInterface } from "./types";

import Customer from "@/types/customer/Customer";
import Investment from "@/types/app/investment";
import Notification from "@/types/app/notifications";
import store from "@/store";
import Schedule from "@/types/app/schedules";
import NotificationInterface from "@/types/app/notifications";
moment.locale("en-US");
export default {
  setCustomers(
    store: ActionContext<CustomerStateInterface, any>,
    customers: Customer[]
  ) {
    store.commit("setCustomers", []);

    customers.forEach((customer) => {
      if (customer.scheduleIndexResponse) {
        if (customer.scheduleIndexResponse.status != "Canceled") {
          customer.scheduleDate = `Meet: ${moment(
            customer.scheduleIndexResponse.startingTime
          )
            .format("DD MMM")
            .toUpperCase()} | ${moment(
            customer.scheduleIndexResponse.startingTime
          ).format("LT")}`;
        } else {
          customer.scheduleDate = "";
        }
      }

      if (customer.relationships && customer.relationships.length > 0) {
        for (let i = 0; i < customer.relationships.length; i++) {
          if (
            customer.status == 0 &&
            customer.relationships[i].typeRelationship == 1
          ) {
            if (customer.relationships[i].name === "") {
              customer.relationship = "--";
            } else {
              customer.relationship = customer.relationships[i].name;
            }
          }

          if (
            (customer.status == 1 || customer.status == 2) &&
            customer.relationships[i].typeRelationship == 0
          ) {
            customer.relationship = customer.relationships[i].name;
          }
        }
      }

      if (customer.scheduleDate !== "" && customer.relationship === null) {
        customer.relationship = "--"; // customer.scheduleDate;
      }
    });
    store.commit("setCustomers", customers);
  },
  setCustomer(
    store: ActionContext<CustomerStateInterface, any>,
    customer: Customer
  ) {
    store.commit("setCustomer", customer);
  },
  removeCustomers(
    store: ActionContext<CustomerStateInterface, any>,
    ids: string[]
  ) {
    store.commit("removeCustomers", ids);
  },
  setLoading(
    store: ActionContext<CustomerStateInterface, any>,
    loading: boolean
  ) {
    store.commit("setLoading", loading);
  },
  setModalInterestState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalInterestState", show);
  },
  setModalCreateInterestState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalCreateInterestState", show);
  },
  setModalImportInterestState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalImportInterestState", show);
  },
  setModalAccountMirrorState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalAccountMirrorState", show);
  },
  setModalInvestmentState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalInvestmentState", show);
  },
  setModalNewNotificationState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNewNotificationState", show);
  },
  setModalNotificationState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNotificationState", show);
  },
  setModalJobInfoState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalJobInfoState", show);
  },
  setModalCustomerState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalCustomerState", show);
  },
  setModalRefusedState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalRefusedState", show);
  },
  setModalRefuseState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalRefuseState", show);
  },
  setModalMessageState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalMessageState", show);
  },
  setInvestmentState(
    store: ActionContext<CustomerStateInterface, any>,
    investment: Investment
  ) {
    store.commit("setInvestmentState", investment);
  },
  removeCustomerFromList(
    store: ActionContext<CustomerStateInterface, any>,
    remover: any
  ) {
    store.commit("removeCustomerFromList", remover);
  },
  setNotificationState(
    store: ActionContext<CustomerStateInterface, any>,
    notification: NotificationInterface
  ) {
    store.commit("setNotificationState", notification);
  },
  setNotificationsState(
    store: ActionContext<CustomerStateInterface, any>,
    notifications: NotificationInterface[]
  ) {
    store.commit("setNotificationsState", notifications);
  },
  setNotificationSent(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setNotificationSent", show);
  },
  setModalDeleteState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalDeleteState", show);
  },
  setUndoRefused(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setUndoRefused", show);
  },
  setScheduleState(
    store: ActionContext<CustomerStateInterface, any>,
    schedule: Schedule
  ) {
    store.commit("setScheduleState", schedule);
  },
  setModalScheduleState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalScheduleState", show);
  },
  setScheduleFeedbackModalState(
    store: ActionContext<CustomerStateInterface, any>,
    show: boolean
  ) {
    store.commit("setScheduleFeedbackModalState", show);
  },
};
